export default __webpack_public_path__ + "static/media/nurse.b71fb3cd.jpg";